import React from "react";

class About extends React.Component {
  render() {
    return (
      <section id="about">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>Introduction</h2>
              <p>The objectives of the National Data Science Challenge (NDSC) are to:</p>
              <ul>
                <li>Equip students and professionals with essential technical skills and expertise to prepare them for the digital and data-driven economy</li>
                <li>Bring the tech community closer through working together and knowledge sharing</li>
                <li>Provide an environment for the development of creative new ideas in Data Science</li>
              </ul>
              <p>Through this competition, we hope to showcase the ubiquity and usefulness of data in getting insights, thus reinforcing Singapore’s emphasis on driving the digital economy and the use of big data.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h3>About the Challenge</h3>
              <div className="row">
                <div className="col-md-6">
                  <div className="challenge-box">
                    <div className="row">
                      <div className="col-3">
                        <img src="images/icon_atom.svg" className="img-fluid" alt="Free & Fun" />
                      </div>
                      <div className="col-9">
                        <h5>Free & Fun</h5>
                        <p>The National Data Science Challenge is free of charge! All you have to do is register and join in the fun.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="challenge-box">
                    <div className="row">
                      <div className="col-3">
                        <img src="images/icon_cube_molecule.svg" className="img-fluid" alt="Eligibility" />
                      </div>
                      <div className="col-9">
                        <h5>Eligibility</h5>
                        <p>Open to students currently enrolled in junior colleges, polytechnics or universities in Singapore (including exchange students) as well as non-tech and tech professionals working in Singapore.</p>
                        <p>Employees of Sea Limited are not eligible to participate in the challenge in the interest of fairness.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="challenge-box">
                    <div className="row">
                      <div className="col-3">
                        <img src="images/icon_head_brains.svg" className="img-fluid" alt="Team" />
                      </div>
                      <div className="col-9">
                        <h5>Team</h5>
                        <p>Form a team of 3-4 members and execute your project over 4 weeks.</p>
                        <p>If you sign up individually, we will assign you to a team.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="challenge-box">
                    <div className="row">
                      <div className="col-3">
                        <img src="images/icon_checkboard_graph.svg" className="img-fluid" alt="Training Workshops" />
                      </div>
                      <div className="col-9">
                        <h5>Training Workshops</h5>
                        <p>Sign up early for the chance to attend training workshops specially organized by our training partners.</p>
                        <p>Training classes catering to both beginner and advanced participants are available.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default About;